import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-primary-600 ${sizeClasses[size]} ${className}`} />
  );
};

interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  message = 'Loading...' 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-gray-600">{message}</p>
    </div>
  );
};

export const SkeletonCard: React.FC = () => {
  return (
    <div className="card animate-pulse">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
        </div>
        <div className="h-6 bg-gray-200 rounded w-16"></div>
      </div>
      
      <div className="mb-4 text-center">
        <div className="h-4 bg-gray-200 rounded mb-2 w-24 mx-auto"></div>
        <div className="h-8 bg-gray-200 rounded w-20 mx-auto"></div>
      </div>
      
      <div className="grid grid-cols-3 gap-2 mb-4">
        <div className="text-center">
          <div className="h-3 bg-gray-200 rounded mb-1"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
        <div className="text-center">
          <div className="h-3 bg-gray-200 rounded mb-1"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
        <div className="text-center">
          <div className="h-3 bg-gray-200 rounded mb-1"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
      
      <div className="flex justify-between items-center pt-3 border-t border-gray-100">
        <div className="h-4 bg-gray-200 rounded w-24"></div>
        <div className="h-4 bg-gray-200 rounded w-16"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;